<template>
  <div class="psap scrollable -y">

    <div class="page-wrapper">
      <psap-page v-if="idToken"></psap-page>
    </div>

  </div>
</template>

<script>
import PsapPage from '@/pages/Psap/PsapPage'
export default {
  name: 'psap',
  components: {
    PsapPage
  },
  computed: {
    idToken: function () {
      return this.$store.getters.idToken
    }
  },
  data: function () {
    return {}
  },
  watch: {
    idToken: function () {
      this.getPsap()
    }
  },
  created: function () {
    this.getPsap()
  },
  methods: {
    getPsap: function () {
      if (this.idToken) {
        this.$store.dispatch('getPsap')
      }
    }
  }
}
</script>

<style scoped>
.psap {
  /* common */
  background-color: hsla(202, 0%, 0%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}

.psap .page-wrapper {
  /* size */
  /* max-width: 400px; */
  min-height: 400px;
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/pages/Psap.vue